// src/components/hero.tsx
"use client";

import Image from "next/image";

export default function Hero() {
  const scrollToContact = () => {
    const el = document.getElementById("contact");
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    else window.location.hash = "#contact";
  };

  return (
    <header role="banner" className="bg-custom-green px-8 py-16 relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-t from-custom-green via-transparent to-transparent z-0 pointer-events-none" />
      <div className="absolute inset-0 z-0 pointer-events-none">
        <Image
          src="/image/felipe.png"
          alt="hero background"
          fill
          priority
          sizes="100vw"
          className="object-contain object-bottom opacity-90 mix-blend-lighten"
        />
      </div>
      <div className="absolute inset-x-0 bottom-0 h-56 bg-white opacity-20 blur-2xl z-10 pointer-events-none" />

      <div className="container mx-auto flex flex-col items-start justify-center min-h-[80vh] text-left px-12 z-20 relative">
        <div className="max-w-2xl z-10">
          <h1 className="leading-none font-bold text-white mb-2 text-[clamp(3rem,14vw,12rem)]">Felipe</h1>
          <h1 className="leading-none font-bold text-white/60 mb-4 text-[clamp(3rem,14vw,12rem)]">Yarns</h1>

          <div className="pl-[0.15em]">
            <p className="mb-8 text-2xl font-bold text-white/90">Musician &amp; Film Director</p>
            <button
              onClick={scrollToContact}
              className="bg-black text-white px-6 py-3 rounded-none text-base font-medium touch-manipulation"
              aria-label="Scroll to contact form"
              type="button"
            >
              GET IN TOUCH
            </button>
          </div>
        </div>
      </div>

      <div className="absolute right-8 bottom-4 z-20">
        <Image src="/image/signature.png" alt="signature" width={100} height={40} className="opacity-80 invert" />
      </div>
    </header>
  );
}